export function addHtmlText(initialHtml) {
  const textHtml =
    '\n\n\n\n<tr>\n<td class="key">Link</td>\n<td class="value">Click here</td>\n';
  const htmlContent = initialHtml.split('</tr>');
  htmlContent.splice(-1, 0, textHtml);

  return htmlContent.join('</tr>');
}
